import { Button, Text, Tooltip } from "@chakra-ui/react";
import { useMemo } from "react";
import { ShowData } from "../../@types/ShowList";
import { Link } from "../../components";
import { SHOW_BOOKING_CLOSED } from "../../constant/alertMessage";
import { AvailabilityColorSchemeEnum } from "../../constant/enums";

function ShowBox({
  isAvailable,
  isViewable,
  lockWeb,
  show_status,
  startTime,
  onClick,
  showDetailLink,
  showButtonProps,
  videoQuality,
  videoQualityBadgeProps,
}: ShowData) {
  const colorScheme = useMemo(() => {
    return show_status === "fast_filling"
      ? AvailabilityColorSchemeEnum.FAST_FILLING
      : show_status === "sold"
        ? AvailabilityColorSchemeEnum.SOLD_OUT
        : show_status === "no-available"
          ? AvailabilityColorSchemeEnum.NOT_AVAILABLE
          : isAvailable
            ? AvailabilityColorSchemeEnum.AVAILABLE
            : "info";
  }, [show_status, isAvailable]);

  // Falls back to `isAvailable` so a caller that has not been updated keeps
  // the old behaviour.
  const canOpen = isViewable ?? isAvailable;

  const showButton = (
    <Button
      borderRadius="5px"
      isDisabled={!canOpen && show_status !== "sold"}
      colorScheme={colorScheme}
      onClick={onClick}
      cursor={!canOpen ? "not-allowed" : "pointer"}
      pointerEvents={!canOpen ? "none" : "auto"}
      position={"relative"}
      opacity={lockWeb ? 0.75 : undefined}
      {...showButtonProps}
    >
      {startTime}
      {videoQuality && (
        <Text
          position={"absolute"}
          bottom={-2}
          fontSize={"10px"}
          bg={"#495acbff"}
          py={1}
          px={2}
          lineHeight={1}
          rounded={"md"}
          {...videoQualityBadgeProps}
        >
          {videoQuality}
        </Text>
      )}
    </Button>
  );

  // A locked show is still reachable: the seat layout is shown read-only.
  const showBoxWithTooltip = lockWeb ? (
    <Tooltip label={SHOW_BOOKING_CLOSED}>{showButton}</Tooltip>
  ) : (
    showButton
  );

  return canOpen ? (
    <Link href={showDetailLink || ""}>{showBoxWithTooltip}</Link>
  ) : (
    showBoxWithTooltip
  );
}

export default ShowBox;
